function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6e6e6e;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2 -2)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M13,17a4,4,0,1,0-4-4,4,4,0,0,0,4,4Zm0-6a2,2,0,1,1-2,2,2,2,0,0,1,2-2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M28.624,19.57a3.489,3.489,0,0,0,.534-3.129l-.635-2.065A4.762,4.762,0,0,0,23.95,11H19.463a1,1,0,0,0,0,2H23.95a2.772,2.772,0,0,1,2.661,1.965l.635,2.065A1.523,1.523,0,0,1,25.791,19H16.622c-.028,0-.052.014-.08.016-.067,0-.132-.016-.2-.016h-6.27A5.166,5.166,0,0,0,5.11,22.665L4.363,25.09A3.8,3.8,0,0,0,7.99,30H18.423a3.8,3.8,0,0,0,3.627-4.91L21.3,22.665A5.2,5.2,0,0,0,20.426,21h5.365a3.489,3.489,0,0,0,2.833-1.43Zm-8.758,7.7A1.778,1.778,0,0,1,18.423,28H7.99a1.794,1.794,0,0,1-1.715-2.322l.746-2.425A3.174,3.174,0,0,1,10.071,21h6.27a3.174,3.174,0,0,1,3.05,2.253l.746,2.425a1.776,1.776,0,0,1-.271,1.594Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M21.5,9A3.5,3.5,0,1,0,18,5.5,3.5,3.5,0,0,0,21.5,9Zm0-5A1.5,1.5,0,1,1,20,5.5,1.5,1.5,0,0,1,21.5,4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M2,6A1,1,0,0,0,3,7H5V9A1,1,0,0,0,7,9V7H9A1,1,0,0,0,9,5H7V3A1,1,0,0,0,5,3V5H3A1,1,0,0,0,2,6Z"
}));

function SvgUsersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.317,
    height: 28,
    viewBox: "0 0 27.317 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.ea5fa5ab.svg";
export { ForwardRef as ReactComponent };